export default "__VITE_ASSET__BAP7v5Qa__"